import type { User } from 'oidc-client-ts';

export const ROLE_CLAIM = 'role';
export const USERNAME_CLAIM = 'username';
export const PSAP_ID_CLAIM = 'psapid';

export function expandClaimToArray(value: unknown): string[] {
  if (value === null || value === undefined) {
    return [];
  }

  if (Array.isArray(value)) {
    return value.map((item) => String(item ?? ''));
  }

  if (typeof value === 'string' && value.startsWith('[')) {
    try {
      const parsed: unknown = JSON.parse(value);
      if (Array.isArray(parsed)) {
        return parsed.map((item) => String(item ?? ''));
      }
    } catch {
      return [String(value)];
    }
  }

  return [String(value)];
}

export function getRoles(user: User | null | undefined): string[] {
  return expandClaimToArray(user?.profile?.[ROLE_CLAIM]);
}

export function hasRole(user: User | null | undefined, role: string): boolean {
  return getRoles(user).includes(role);
}

export function hasAnyRole(user: User | null | undefined, roles: readonly string[]): boolean {
  const userRoles = getRoles(user);
  return roles.some((role) => userRoles.includes(role));
}

export function getUsername(user: User | null | undefined): string | undefined {
  const username = user?.profile?.[USERNAME_CLAIM];
  return typeof username === 'string' ? username : undefined;
}

export function getPsapId(user: User | null | undefined): string | undefined {
  const psapId = user?.profile?.[PSAP_ID_CLAIM];
  return typeof psapId === 'string' ? psapId : undefined;
}
